export function binarySearch(data, value, findPositionForNew) {
    let r = data.length, l = -1, m;
    while (r - l > 1) {
        if (data[(m = (r + l) >> 1)] < value)
            l = m;
        else
            r = m;
    }
    return data[r] != value ? (findPositionForNew ? r : -1) : r;
}
export function binarySearchByField(data, field, value) {
    let r = data.length;
    let l = -1;
    let m;
    while (r - l > 1) {
        m = (r + l) >> 1;
        if (data[m][field] < value)
            l = m;
        else
            r = m;
    }
    return { l, r };
}
export function binarySearchByIndex0(data, value) {
    return binarySearchByField(data, 0, value);
}
